export interface AddressComponent {
  types: string[];
  longText: string;
  shortText: string;
}

// Prefer locality when Google returns both New York and a borough such as Brooklyn.
const CITY_TYPES = ['locality', 'postal_town', 'sublocality_level_1', 'sublocality'];

export const parseAddressComponents = (addressComponents: readonly AddressComponent[]) => {
  let streetAddress = '';
  const streetNumber = addressComponents.find(component => component.types.includes('street_number'));
  const streetName = addressComponents.find(component => component.types.includes('route'));
  const city = CITY_TYPES.map(type => addressComponents.find(component => component.types.includes(type))).find(
    component => component,
  )?.longText;
  const region = addressComponents.find(component =>
    component.types.includes('administrative_area_level_1'),
  )?.shortText;
  const postalCode = addressComponents.find(component => component.types.includes('postal_code'))?.longText;

  if (streetNumber) streetAddress += streetNumber.longText + ' ';
  if (streetName) streetAddress += streetName.shortText;

  return { streetAddress, city, region, postalCode };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAddressFromAutoCompleteSuggestion = async (suggestion: any) => {
  const place = suggestion.placePrediction.toPlace();
  await place.fetchFields({ fields: ['addressComponents'] });

  const addressComponents = place.addressComponents as AddressComponent[];

  if (addressComponents) return parseAddressComponents(addressComponents);

  return null;
};
